

export const tratamientosList = [
  {
    id: 1,
    name: "Extracciones",
    details: [
      "Simples",
      "Complejas"
         ]    
    
  },
  {
    id: 2,
    name: "Tratamientos de conducto",
    details: [
      "Unirradicular",
      "Birradicular",
      "Molar"
    ]
 },

  {
    id: 3,
    name: "Protesis",
    details: ["Completa", "Parcial a placa ", "Parcial a cromo"]
  },
  {
    id: 4,
    name: "Puentes",
    details: ["3 piezas", "4 piezas", "5 piezas"]
  },
  {
    id: 5,
    name: "Coronas",
    details: ["Corona porcelana", "Corona metal acrílico", "Corona metal"]
  },
  {
    id: 6,
    name: "Blanqueamiento",
    details: ["Dientes relucientes en una sola sesión"]
  },
  { id: 7, 
    name: "Placa miorrelajante", 
    details: ["Hechas a medida para mitigar los daños del bruxismo"]
  },
    {
    id: 8,
    name: "Tratamiento de caries",
    details: ["Carie simples, resina", "Carie grande resina"]
  },
];
